const initVisiblePassword = () => {
  const visiblePasswordList = document.querySelectorAll(".js-visible-password");
  visiblePasswordList.forEach((input) => {
    var _a;
    const button = (_a = input == null ? void 0 : input.closest(".form-group, .input-group")) == null ? void 0 : _a.querySelector('button[data-action="show-password"]');
    button == null ? void 0 : button.addEventListener("click", () => {
      const newType = input.getAttribute("type") === "text" ? "password" : "text";
      input.setAttribute("type", newType);
      const icon = button.firstElementChild;
      if (icon) {
        icon.className = newType === "text" ? "uil uil-eye-slash" : "uil uil-eye";
      }
    });
  });
};
export default initVisiblePassword;
